import { render, staticRenderFns } from "./NewMarket.vue?vue&type=template&id=65b20ec9&scoped=true&"
import script from "./NewMarket.ts?vue&type=script&lang=ts&"
export * from "./NewMarket.ts?vue&type=script&lang=ts&"
import style0 from "./NewMarket.scss?vue&type=style&index=0&id=65b20ec9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b20ec9",
  null
  
)

export default component.exports